import { InputLabel, Stack } from '@mui/material';
import { Controller, FieldValues } from 'react-hook-form';

import TimeInput from 'kerberus-components/src/Components/Time/TimeInput';

import { BaseInputProps } from './GetFormInput';

export function FormDate<T extends FieldValues>({ control, label, required, value }: Readonly<BaseInputProps<T>>) {
    return (
        <Controller
            control={control}
            name={value}
            render={({ field: { onChange, value } }) => (
                <Stack spacing={2}>
                    <InputLabel sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>{label}</InputLabel>
                    <TimeInput durationValue={value as string} label="" onChange={onChange} />
                </Stack>
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
            }}
        />
    );
}
